module.exports = __webpack_public_path__ + "static/media/product-3.6f7afb00.jpg";